import React, { useContext } from "react";
import {
  Box,
  Icon,
  HStack,
  Divider,
  Text,
  VStack,
  Accordion,
} from "@chakra-ui/react";
import Item from "./Item";
import { logOut } from "../../../Utils/auth";
import { Link } from "react-router-dom";
import { AiFillHome } from "react-icons/ai";
import {
  BsFillCartPlusFill,
  BsFillCartFill,
  BsFillCartXFill,
  BsFillCartCheckFill,
  BsBoxSeam,
  BsBoxArrowInRight,
} from "react-icons/bs";
import { FiPlus, FiTruck } from "react-icons/fi";
import {
  RiListCheck,
  RiPlayListAddLine,
  RiUserShared2Fill,
  RiUserStarFill,
  RiUserAddFill,
  RiUserSettingsFill,
} from "react-icons/ri";
import { SiGooglemaps } from "react-icons/si";
import { BiExit } from "react-icons/bi";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { TbLock } from "react-icons/tb";
import { UsersContext } from "../../Context/UsersContext";
import { useLocation } from "react-router-dom";

const MenuList = ({ onClose = null }) => {
  const { currentUser } = useContext(UsersContext);
  const location = useLocation();

  const itemList = [
    {
      title: "Pedidos",
      sections: [
        {
          name: "Creados",
          icon: <Icon as={BsFillCartPlusFill}></Icon>,
          url: "/pedidos/lista/creados",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
        {
          name: "Pendientes",
          icon: <Icon as={BsFillCartXFill}></Icon>,
          url: "/pedidos/lista/pendientes",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
        {
          name: "Entrega",
          icon: <Icon as={BsFillCartFill}></Icon>,
          url: "/pedidos/lista/entregas",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
        {
          name: "Finalizado",
          icon: <Icon as={BsFillCartCheckFill}></Icon>,
          url: "/pedidos/lista/finalizados",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
      ],
    },
    {
      title: "Artículos",
      sections: [
        {
          name: "Listado",
          icon: <Icon as={BsBoxSeam}></Icon>,
          url: "/articulos",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
        {
          name: "Categorías",
          icon: <Icon as={BsBoxSeam}></Icon>,
          url: "/categorias",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
        {
          name: "Nuevo Artículo",
          icon: <Icon as={FiPlus}></Icon>,
          url: "/articulos/nuevo",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
      ],
    },
    {
      title: "Compras",
      sections: [
        {
          name: "Listado",
          icon: <Icon as={BsBoxArrowInRight}></Icon>,
          url: "/compras",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
        {
          name: "Nueva Compra",
          icon: <Icon as={FiPlus}></Icon>,
          url: "/compras/nueva",
          iconUrl: "react-icons/fa",
          minRole: 2,
          actionsIdAllowed: [13],
        },
      ],
    },
    {
      title: "Proveedores",
      sections: [
        {
          name: "Listado",
          icon: <Icon as={FiTruck}></Icon>,
          url: "/proveedores",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
        {
          name: "Nuevo Proveedor",
          icon: <Icon as={FiPlus}></Icon>,
          url: "/proveedores/new",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
      ],
    },
    {
      title: "Listas de precios",
      sections: [
        {
          icon: <Icon as={RiListCheck}></Icon>,
          name: "Listas",
          url: "/lista-de-precios",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
        {
          name: "Nueva Lista",
          icon: <Icon as={RiPlayListAddLine}></Icon>,
          url: "/lista-de-precios/new",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
      ],
    },
    {
      title: "Usuarios",
      sections: [
        {
          name: "Clientes",
          icon: <Icon as={RiUserStarFill}></Icon>,
          url: "/clientes",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
        {
          name: "Vendedores",
          icon: <Icon as={RiUserShared2Fill}></Icon>,
          url: "/vendedores",
          minRole: 2,
        },
        {
          name: "Operadores",
          icon: <Icon as={RiUserSettingsFill}></Icon>,
          url: "/operadores",
          iconUrl: "react-icons/fa",
          minRole: 1,
        },
        {
          name: "Zonas",
          icon: <Icon as={SiGooglemaps}></Icon>,
          url: "/usuarios/zonas",
          iconUrl: "react-icons/fa",
        },
        {
          name: "Nuevo Usuario",
          icon: <Icon as={RiUserAddFill}></Icon>,
          url: "/usuarios/nuevo",
          iconUrl: "react-icons/fa",
          minRole: 2,
        },
      ],
    },
    {
      title: "Reportes",
      sections: [
        {
          name: "Facturacion",
          icon: <Icon as={HiOutlineDocumentReport}></Icon>,
          url: "/reportes/facturacion",
          iconUrl: "react-icons/fa",
          minRole: 2,
          actionsIdAllowed: [8],
        },
        {
          name: "Artículos",
          icon: <Icon as={HiOutlineDocumentReport}></Icon>,
          url: "/reportes/articulos",
          iconUrl: "react-icons/fa",
          minRole: 2,
          actionsIdAllowed: [8],
        },
        {
          name: "Compras",
          icon: <Icon as={HiOutlineDocumentReport}></Icon>,
          url: "/reportes/compras",
          iconUrl: "react-icons/fa",
          minRole: 2,
          actionsIdAllowed: [8],
        },
        {
          name: "Stock Valorizado",
          icon: <Icon as={HiOutlineDocumentReport}></Icon>,
          url: "/reportes/stock-valorizado",
          iconUrl: "react-icons/fa",
          minRole: 2,
          actionsIdAllowed: [8],
        },
        {
          name: "Stock Minimo",
          icon: <Icon as={HiOutlineDocumentReport}></Icon>,
          url: "/reportes/stock-minimo",
          iconUrl: "react-icons/fa",
          minRole: 2,
          actionsIdAllowed: [8, 9],
        },
      ],
      actionsIdAllowed: [8, 9],
    },
    {
      title: "Permisos",
      sections: [
        {
          name: "Permisos de Operadores",
          icon: <Icon as={TbLock}></Icon>,
          url: "/permisos",
          iconUrl: "react-icons/fa",
          minRole: 1,
        },
      ],
    },
  ];

  const getActualIndex = () => {
    return itemList.findIndex((item) =>
      item.sections.find((section) => section.url === location.pathname)
    );
  };

  return (
    <>
      <VStack spacing="20px" align="left" color="menu.700">
        <Box>
          <Text color="menu.700">Bienvenido, </Text>
          <Text color="menu.100">
            {currentUser.firstName} {currentUser.lastName}
          </Text>
        </Box>
        <Box>
          <Box pl="0.5rem" pb="0.5rem">
            <Link to={"/"}>
              <HStack
                _hover={{ color: "menu.100" }}
                pl="0.5rem"
                spacing="1"
                color={location.pathname === "/" ? "white" : "inherit"}
              >
                <Icon as={AiFillHome}></Icon>
                <Text fontSize="0.9rem" pl={"0.25rem"}>
                  Home
                </Text>
              </HStack>
            </Link>
          </Box>
          <Accordion allowMultiple defaultIndex={[getActualIndex()]}>
            {itemList.map((item, index) => (
              <Item
                key={index}
                onClose={onClose}
                title={item.title}
                sections={item.sections}
                actionsIdAllowed={item.actionsIdAllowed}
              ></Item>
            ))}
          </Accordion>
        </Box>
        <Box pt="1rem" color="menu.100">
          <Divider backgroundColor="menu.700"></Divider>
          <HStack
            justifyContent={"space-between"}
            _hover={{ cursor: "pointer" }}
            onClick={() => logOut()}
            m="1rem 0"
          >
            <Box _hover={{ cursor: "pointer" }} fontSize="sm">
              Cerrar sesion
            </Box>
            <Icon as={BiExit}></Icon>
          </HStack>
        </Box>
      </VStack>
    </>
  );
};

export default MenuList;
